import { render, staticRenderFns } from "./user-devices.vue?vue&type=template&id=0085a2a0&"
import script from "./user-devices.vue?vue&type=script&lang=ts&"
export * from "./user-devices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports